import Swiper from "swiper/bundle";

export default () => {
  document.querySelectorAll(".js-hero-slider").forEach((heroSlider) => {
    if (
      document.querySelector(".js-hero-slider-thumbs") &&
      document.querySelector(".js-hero-slider-main")
    ) {
      const heroSliderThumbs = new Swiper(".js-hero-slider-thumbs", {
        a11y: true,
        allowTouchMove: matchMedia("(max-width: 909px)").matches ? true : false,
        observer: true,
        observeParents: true,
        preventClicks: false,
        preventClicksPropagation: false,
        slidesPerView: matchMedia("(max-width: 909px)").matches ? 2 : 4,
        // spaceBetween: 30,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
      });

      const heroSliderMain = new Swiper(".js-hero-slider-main", {
        a11y: true,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        loop: true,
        observer: true,
        observeParents: true,
        pagination: {
          el: ".swiper-pagination",
        },
        slidesPerView: 1,
        thumbs: {
          swiper: heroSliderThumbs,
        },
      });

      const playButton = heroSlider.querySelector(".js-hero-slider-play-btn");
      const pauseButton = heroSlider.querySelector(".js-hero-slider-pause-btn");

      if (playButton) {
        playButton?.addEventListener("click", () => {
          playButton?.classList.add("hidden");
          pauseButton?.classList.remove("hidden");

          heroSliderMain?.autoplay.start();
        });
      }

      if (pauseButton) {
        pauseButton?.addEventListener("click", () => {
          pauseButton?.classList.add("hidden");
          playButton?.classList.remove("hidden");

          heroSliderMain?.autoplay.stop();
        });
      }
    }
  });
};
